import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { environment } from '@shared-envs';

interface FollowingUser {
  userId: number;
  nickname: string;
  icon?: string;
  firstName?: string;
  lastName?: string;
}

@Component({
  selector: 'ark-lib-add-co-founder-modal',
  templateUrl: './add-co-founder-modal.component.html',
  styleUrls: ['./add-co-founder-modal.component.css'],
})
export class AddCoFounderModalComponent implements OnInit {
  @Input() existingCoFounders: FollowingUser[] = [];
  @Input() allFollowing: FollowingUser[] = [];

  availableCofounders: FollowingUser[] = [];
  selectedCoFounders: FollowingUser[] = [];

  private searchSubject = new Subject<string>();
  loading = true;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    environment.log('ngOnInit - allFollowing:', this.allFollowing);
    environment.log('ngOnInit - existingCoFounders:', this.existingCoFounders);

    // restore existing selections
    this.selectedCoFounders = [...this.existingCoFounders];

    // initialize available list
    this.updateAvailableCofounders();

    this.loading = false;

    // search
    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((query) => this.updateAvailableCofounders(query));
  }

  private updateAvailableCofounders(query: string = '') {
    const normalized = query.toLowerCase().trim();

    this.availableCofounders = this.allFollowing
      // exclude already selected
      .filter(
        (u) => !this.selectedCoFounders.find((c) => c.userId === u.userId),
      )
      // apply search if query exists
      .filter((u) => {
        if (!normalized) return true;
        const fullName =
          `${u.firstName ?? ''} ${u.lastName ?? ''}`.toLowerCase();
        const nickname = u.nickname ? u.nickname.toLowerCase() : '';
        return fullName.includes(normalized) || nickname.includes(normalized);
      });
  }

  onSearchChange(value: string | null | undefined) {
    this.searchSubject.next(value ?? '');
  }

  onCoFounderSelect(user: FollowingUser) {
    if (!this.selectedCoFounders.find((c) => c.userId === user.userId)) {
      this.selectedCoFounders.push(user);
      this.updateAvailableCofounders();
    }
  }

  removeSelectedCoFounder(coFounder: FollowingUser) {
    this.selectedCoFounders = this.selectedCoFounders.filter(
      (c) => c.userId !== coFounder.userId,
    );
    this.updateAvailableCofounders();
  }

  finalizeSelection() {
    this.modalCtrl.dismiss(this.selectedCoFounders);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }
}
